(function () {
    'use strict';

    function contractorDataService() {
        var baseUrl = '[BuildifyApiHost]/api/';

        function loadContractor(id) {
            return $http.get(baseUrl + 'Contractors/' + id).then(function (response) {
                return response.data;
            });
        };

        function saveContractor(id, data) {
            return $http.put(baseUrl + id, data).then(
                function (response) { return true; }
            );
        };


        return {
            loadContractor: loadContractor,
            saveContractor: saveContractor
        }
    }

    contractorDataService.$inject = [];

    angular.module('ecap.common').service('contractorDataService', contractorDataService);
})();
